<template>
    <GmapMap
        v-show="mapInitialized"
        ref="map"
        :style="{ minHeight }"
        :center="center"
        :zoom="19"
        :options="{
            draggable: false,
            disableDefaultUI: true,
            disableDoubleClickZoom: true,
            keyboardShortcuts: false,
            scrollwheel: false,
        }"
        map-type-id="satellite"
    >
        <GmapMarker :position="center" />
    </GmapMap>
</template>

<script>
import { lsErrorService } from 'ls-vue-common';
import { gmapApi } from 'vue2-google-maps';

export default {
    name: 'LsGoogleMap',
    props: {
        lat: { type: Number },
        lng: { type: Number },
        address: { type: String },
        minHeight: { type: String, default: '175px' },
    },
    data() {
        return {
            mapInitialized: this.lat && this.lng,
            center: {
                lat: this.lat,
                lng: this.lng,
            },
        };
    },
    computed: {
        google: gmapApi,
    },
    mounted() {
        this.$refs.map.$mapPromise.then(() => {
            if (!this.mapInitialized && this.address) {
                const Geocoder = new this.google.maps.Geocoder();
                Geocoder.geocode({ address: this.address }, (results, status) => {
                    if (status === this.google.maps.GeocoderStatus.OK) {
                        this.center = {
                            lat: results[0].geometry.location.lat(),
                            lng: results[0].geometry.location.lng(),
                        };
                        this.mapInitialized = true;
                    } else {
                        lsErrorService.log({
                            error: {
                                message: 'Geocoder did not obtain address coordinates',
                                level: 'warning',
                            },
                        });
                    }
                });
            } else if (!this.address) {
                lsErrorService.log({
                    error: {
                        message: 'No parameters were passed to the GoogleMap component',
                        level: 'warning',
                    },
                });
            }
        });
    },
};
</script>
